import React, { Fragment, useEffect, useState } from "react";
import { Grid } from "@mui/material";

import { Mandatory } from "../FormOne";
import { Autocomplete } from "../../../../components";
import AutocompleteMultiSelect from "../../../../components/MultiselectAutoComplete";

function DropDown({ state, field, editState, dispatch }) {
  const [input, setInput] = useState({});

  useEffect(() => {
    if (state[field.name]) {
      setInput((prev) => ({
        ...prev,
        [field.name]: state[field.name],
      }));
    }
  }, [state, field.name]);

  return (
    <Fragment>
      {field.control_id === 2 && field.multi_select && (
        <Grid size={6}>
          <AutocompleteMultiSelect
            size="small"
            forcePopupIcon={!editState ? false : true}
            label={field.label}
            name={`${field.name}.value`}
            state={state}
            value={input[field.name]?.value}
            disabled={!editState}
            defaults={{
              primaryKey: "value",
              displayLabel: "label",
            }}
            options={[
              ...(field.options.length > 5
                ? [{ value: "ALL", label: "Select All" }]
                : []),
              ...field.options,
            ]}
            showSelectAll={true}
            placeholder={
              input[field.name]?.value?.length === 0 && field.placeholder
            }
            onChange={(_, arr, reason, detail) => {
              handleChange(
                arr,
                detail,
                reason,
                `${field.name}.value`,
                "value",
                field.options
              );
            }}
            onBlur={() => {
              handleDropDown(
                input[field.name]?.value,
                field.name,
                "value",
                field.segment_id
              );
            }}
          />
        </Grid>
      )}

      {field.control_id === 2 && !field.multi_select && (
        <Grid size={6}>
          <Mandatory field={field} />

          <Autocomplete
            size="small"
            label={field.label}
            forcePopupIcon={!editState ? false : true}
            name={`${field.name}.value`}
            placeholder={field.placeholder}
            value={input[field.name]?.value}
            defaults={{
              primaryKey: "value",
              displayLabel: "label",
            }}
            sx={{
              "& .MuiSvgIcon-root": {
                display: !editState && "none",
              },
            }}
            options={field.options}
            disabled={!editState}
            onChange={(_, value, type) =>
              handleChangeSingleSelect(value, type, `${field.name}`)
            }
            onBlur={() => {
              handleDropDown(input[field.name].value, field.name, "value");
            }}
          />
        </Grid>
      )}
    </Fragment>
  );

  function handleDropDown(value, name, key, segmentID) {
    dispatch({
      type: "MULTI_DROP_DOWN",
      payload: { value, name, key, segmentID },
    });
  }

  function handleChangeSingleSelect(value, type, name) {
    function setValue(val) {
      return value.value;
    }

    if (type === "selectOption") {
      setInput((prev) => ({
        ...prev,
        [name]: { value: setValue(input[name]) },
      }));
    } else {
      value = {
        value: "",
        label: "",
      };

      setInput({ [name]: { value: setValue(input[name]) } });
    }
  }

  function handleChange(arr, detail, reason, name, displayName, options) {
    let objectName = name.substring(0, name.indexOf("."));

    setInput((prev) => ({
      ...prev,
      [objectName]: setValuesOfDropDown(input[objectName]?.value),
    }));

    function setValuesOfDropDown(val = []) {
      let values = [...val];

      if (reason === "clear" && arr?.length === 0) {
        return { value: [] };
      }

      let { option } = detail;

      if (option?.value === "ALL") {
        const allValues = options.map((item) => item[displayName]);

        const allSelected = values.length === options.length + 1;

        values = allSelected ? [] : [...allValues, "ALL"];
      } else if (reason === "removeOption") {
        if (option?.value) {
          values = values.filter((items) => items !== option?.value);
          values = values.filter((item) => item !== "ALL");
        } else {
          values?.pop();
          option = options.find((item) => item?.label === option);
        }
      } else if (reason === "selectOption") {
        if (!values.includes(option[displayName])) {
          values.push(option[displayName]);
        }
        const allValues = options.map((item) => item[displayName]);
        const withoutAll = values.filter((v) => v !== "ALL");

        if (withoutAll.length === allValues.length) {
          values = ["ALL", ...allValues];
        }
      }

      return { value: values };
    }
  }
}

export default DropDown;
